enum AgentsAssistanceTypes {
    SET_AGENTS_ASSISTANCE_STATE = 'SET_AGENTS_ASSISTANCE_STATE',
    RESET_AGENTS_ASSISTANCE_STATE = 'RESET_AGENTS_ASSISTANCE_STATE',
}

export default AgentsAssistanceTypes;